import { expireSoon, dateSentence } from 'helpers/date';
import { VoucherStatus } from 'models';
import { Wrapper, AlertIcon, AlarmIcon, CheckIcon, StyledMarkdown } from './VoucherState.styles';

interface VoucherStateProps {
  date: string;
  showDate?: boolean;
  className?: string;
  status?: VoucherStatus;
}

interface VoucherStateContent {
  label: string;
  text: string;
  icon: any;
  showIcon: boolean;
}

const VoucherState = ({
  date,
  showDate = false,
  status = 'active',
  className,
}: VoucherStateProps) => {
  const isAlert = expireSoon(date);

  const content: Record<VoucherStatus, VoucherStateContent> = {
    active: {
      label: 'Expiry Date',
      text: dateSentence(isAlert, showDate, date),
      icon: AlertIcon,
      showIcon: isAlert,
    },
    expired: {
      label: 'Expired',
      text: 'Expired',
      icon: AlarmIcon,
      showIcon: true,
    },
    redeemed: {
      label: 'Redeemed',
      text: 'Redeemed',
      icon: CheckIcon,
      showIcon: true,
    },
  };

  const { label, text, icon: Icon, showIcon } = content[status];

  return (
    <Wrapper className={className} aria-label={label}>
      {showIcon && <Icon />}
      <StyledMarkdown showIcon={showIcon}>{text}</StyledMarkdown>
    </Wrapper>
  );
};

export default VoucherState;
